<template>
  <div ref="supportTicketHisoryTable" class="referrals-history-table">
    <div class="referrals-history-table-column">
      <div class="referrals-history-table-header">
        <div>
          <h1>Ticket History</h1>
          <p>An overview of your ticket activity</p>
        </div>
        <div>
          <p style="cursor: pointer">REFRESH</p>
        </div>
      </div>
      <div class="referrals-history-actual-table-header">
        <div class="referrals-history-table-actual-table-header-container">
          <div class="referrals-history-table-actual-table-header-id">ID</div>
          <div class="referrals-history-table-actual-table-header-timedate">
            Ticket Name
          </div>
          <div class="referrals-history-table-actual-table-header-email">
            Activity
          </div>
          <div class="referrals-history-table-actual-table-header-active">
            Active
          </div>
          <div class="referrals-history-table-actual-table-header-money-spent">
            Date
          </div>
          <div class="referrals-history-table-actual-table-header-add-friend">
            Close Ticket
          </div>
        </div>
      </div>
      <div class="referrals-history-table-actual-table">
        <div class="referrals-history-table-actual-table-item">
          <div class="referrals-history-table-actual-table-item-container">
            <div class="referrals-history-table-actual-table-item-id">1</div>
            <div class="referrals-history-table-actual-table-item-timedate">
              Apr 12th, 2019
            </div>
            <div class="referrals-history-table-actual-table-item-email">
              as808780@gmail.com
            </div>
            <div class="referrals-history-table-actual-table-item-active">
              False
            </div>
            <div class="referrals-history-table-actual-table-item-money-spent">
              $12
            </div>
            <div class="referrals-history-table-actual-table-item-add-friend">
              <img src="../../../assets/img/close.svg" />
            </div>
          </div>
        </div>

        <div class="referrals-history-table-actual-table-item">
          <div class="referrals-history-table-actual-table-item-container">
            <div class="referrals-history-table-actual-table-item-id">1</div>
            <div class="referrals-history-table-actual-table-item-timedate">
              Apr 12th, 2019
            </div>
            <div class="referrals-history-table-actual-table-item-email">
              as808780@gmail.com
            </div>
            <div class="referrals-history-table-actual-table-item-active">
              False
            </div>
            <div class="referrals-history-table-actual-table-item-money-spent">
              $12
            </div>
            <div class="referrals-history-table-actual-table-item-add-friend">
              <img src="../../../assets/img/close.svg" />
            </div>
          </div>
        </div>

        <div class="referrals-history-table-actual-table-item">
          <div class="referrals-history-table-actual-table-item-container">
            <div class="referrals-history-table-actual-table-item-id">1</div>
            <div class="referrals-history-table-actual-table-item-timedate">
              Apr 12th, 2019
            </div>
            <div class="referrals-history-table-actual-table-item-email">
              as808780@gmail.com
            </div>
            <div class="referrals-history-table-actual-table-item-active">
              False
            </div>
            <div class="referrals-history-table-actual-table-item-money-spent">
              $12
            </div>
            <div class="referrals-history-table-actual-table-item-add-friend">
              <img src="../../../assets/img/close.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    async mounted() {
    await this.sleep(80);
    this.$refs.supportTicketHisoryTable.style = "transform: scale(1) !important";
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style scoped>
.referrals-history-table {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 650px;
  max-width: 100%;
  width: 100%;
  height: 650px;
  background: radial-gradient(
    100% 100% at 44.04% 0%,
    #26292e85 0%,
    #1a1c1f 100%
  );
  mix-blend-mode: normal;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.0835883), inset 0px 1px 3px #000000;
  border-radius: 7px;
  transform: scale(0.5);
  transition: 0.4s;
}
.referrals-history-table-column {
  margin: 15px;
  height: 95%;
  width: 95%;
}

.referrals-history-table-header {
  display: flex;
  justify-content: space-between;
}

.referrals-history-table-header > div:nth-of-type(odd) {
  display: flex;
  flex-direction: column;
}
.referrals-history-table-header > div:nth-of-type(odd) > h1 {
  color: #e0e0e0;
  font-size: 20px;
  font-family: "OpenSans";
}
.referrals-history-table-header > div:nth-of-type(odd) > p {
  color: #888888;
  font-size: 12px;
}
.referrals-history-table-header > div:nth-of-type(even) > p {
  color: #888888;
  font-size: 10px;
}

.referrals-history-actual-table-header {
  display: flex;
  margin-top: 20px;
  color: #888888;
  font-family: "OpenSans-Bold";
  width: 100%;
  justify-content: space-evenly;
}

.referrals-history-table-actual-table-header-container {
  width: 90%;
  display: flex;
}

.referrals-history-table-actual-table-header-id {
  flex: 0.1;
}
.referrals-history-table-actual-table-header-timedate {
  flex: 0.1;
}
.referrals-history-table-actual-table-header-active {
  flex: 0.1;
}
.referrals-history-table-actual-table-header-email {
  flex: 0.4;
  display: flex;
  justify-content: center;
}
.referrals-history-table-actual-table-header-money-spent {
  flex: 0.2;
}
.referrals-history-table-actual-table-header-add-friend {
  flex: 0.1;
  display: flex;
  justify-content: center;
}

.referrals-history-table-actual-table-item-id {
  flex: 0.1;
}
.referrals-history-table-actual-table-item-timedate {
  flex: 0.1;
}
.referrals-history-table-actual-table-item-active {
  flex: 0.1;
}
.referrals-history-table-actual-table-item-email {
  flex: 0.4;
  display: flex;
  justify-content: center;
}
.referrals-history-table-actual-table-item-money-spent {
  flex: 0.2;
}
.referrals-history-table-actual-table-item-add-friend {
  flex: 0.1;
  display: flex;
  justify-content: center;
}
.referrals-history-table-actual-table {
  background-color: #131517;
  height: 480px;
  margin-top: 5px;
  border-radius: 10px;
  padding: 20px;
  overflow-x: auto;
}
.referrals-history-table-actual-table-item {
  height: 45px;
  width: 100%;
  background: radial-gradient(
    100% 100% at 44.04% 0%,
    rgba(38, 41, 46, 0.5) 0%,
    #1a1c1f 100%
  );
  mix-blend-mode: normal;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.0835883);
  border-radius: 10px;
  display: flex;
  justify-content: space-evenly;
  margin-top: 10px;
  min-width: 700px;
}

.referrals-history-table-actual-table-item-container {
  width: 93.5%;
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 12px;
  color: #888888;
}
</style>
